import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const MedicationCategoryService = {
    getMedicationCategoriesList(params){ return axiosRequest('GET', API_PATH.MEDICATION_CATEGORY.LIST(params)) },
    getMedicationCategory(data){ return axiosRequest('POST', API_PATH.MEDICATION_CATEGORY.INFO, data) },
    addMedicationCategory(data){ return axiosRequest('POST', API_PATH.MEDICATION_CATEGORY.ADD, data) },
    deleteMedicationCategory(data){ return axiosRequest('POST', API_PATH.MEDICATION_CATEGORY.DELETE, data) },
}